import React from "react";
import { Box, Typography, Grid, Card, CardContent} from "@mui/material";
import CloudIcon from "@mui/icons-material/Cloud";
import EditDocumentIcon from '@mui/icons-material/EditDocument';
import MemoryIcon from '@mui/icons-material/Memory';
import DragIndicatorIcon from '@mui/icons-material/DragIndicator';
import {
  BuildCircle as BuildCircleIcon,
  FolderSpecial as FolderSpecialIcon,
  Storage as StorageIcon,
  Layers as LayersIcon,
  Transform as TransformIcon,
  AccountTree as AccountTreeIcon,
  CheckCircle as CheckCircleIcon,
  CompareArrows as CompareArrowsIcon,
  ChevronLeft as ChevronLeftIcon,
  ChevronRight as ChevronRightIcon,
} from '@mui/icons-material';



const featuresData = [
  {
    id: 1,
    title: 'Web based Editor',
    description: 'Create and edit directly in your browser with an intuitive, simple editor.',
    icon: BuildCircleIcon,
    color: '#FF6B6B',
  },
  {
    id: 2,
    title: 'Library Management',
    description: 'Organize and manage your libraries efficiently in one place.',
    icon: FolderSpecialIcon,
    color: '#4ECDC4',
  },
  {
    id: 3,
    title: 'Pre-built Libraries',
    description: 'Access pre-built libraries that speed up your learning.',
    icon: StorageIcon,
    color: '#45B7D1',
  },
  {
    id: 4,
    title: 'Create Schematics',
    description: 'Design schematics and strengthen your basics.',
    icon: LayersIcon,
    color: '#96CEB4',
  },
  {
    id: 5,
    title: 'Create Symbols from Schematics',
    description: 'A rectangular shaped symbol for a schematic that can be used in other schematics.',
    icon: TransformIcon,
    color: '#FFEAA7',
  },
  {
    id: 6,
    title: 'Create Stick Diagrams',
    description: 'Develop intuition for how schematics translate into layout by writing stick diagrams.',
    icon: AccountTreeIcon,
    color: '#DDA15E',
  },
  {
    id: 7,
    title: 'Netlists for Schematics and Stick',
    description: 'Translates schematics and stick diagrams into a text-based format defining connections between components, pins, and nets.',
    icon: CheckCircleIcon,
    color: '#BC6C25',
  },
  {
    id: 8,
    title: 'Schematics versus Stick (SVS) Validation',
    description: 'Validate and compare a stick diagram against schematics to ensure correctness.',
    icon: CompareArrowsIcon,
    color: '#6C5B7B',
  },
];
const FeaturesSection = () => {
  return (
    <Box>
      
      <Grid container spacing={3}>
        {featuresData.map((feature) => {
          const Icon = feature.icon;

          return (
            <Grid key={feature.id} size={{ xs: 12, sm: 6, md: 6, lg: 4 }}>
              <Card sx={{ height: "100%" }}>
                <CardContent sx={{ textAlign: "center" }}>
                  <Icon sx={{ fontSize: 50, color: feature.color }} />

                  <Typography variant="h6" fontWeight="bold" sx={{ mt: 2 }}>
                    {feature.title}
                  </Typography>

                  <Typography variant="body2">
                    {feature.description} 
                  </Typography>
                </CardContent>
              </Card>
            </Grid>
          );
        })}
      </Grid>
    </Box>
  );
};

export default FeaturesSection;
